import actions from 'src/modules/event/clone/eventCloneActions';

const initialData = {
  loading: false,
};

export default (state = initialData, { type, payload }) => {
  if (type === actions.CLONE_ALL_STARTED) {
    return {
      ...state,
      loading: true,
    };
  }

  if (type === actions.CLONE_ALL_SUCCESS) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.CLONE_ALL_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.CLONE_STARTED) {
    return {
      ...state,
      loading: true,
    };
  }

  if (type === actions.CLONE_SUCCESS) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.CLONE_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  return state;
};

